import React from 'react';
import ApiActionButton from '@/components/Exceptions/ActionButtons/ApiActionButton';
import { ExceptionApiAction, ExceptionReference } from '@/redux/slices/slice_types';
import OverflowMenuItem from '@/components/_common/OverflowMenu/OverflowMenuItem';
import { PolarisIcon } from '@/exports/columnCommonComponents';
import { getActionButtonLabel, getActionConfirmationDialogMessage } from '@/components/Exceptions/utils/utils';

interface Props {
  action: ExceptionApiAction;
  references: ExceptionReference[];
}

const OverflowMenuApiActionButton: React.FC<Props> = ({ action, references }) => {
  const label = getActionButtonLabel(action, references);
  const dialogConfirmationMessage = getActionConfirmationDialogMessage(action.name);

  return (
    <ApiActionButton action={action} dialogConfirmationMessage={dialogConfirmationMessage}>
      {({ dialog, iconName, openDialog }) => (
        <>
          <OverflowMenuItem onClick={openDialog}>
            <PolarisIcon icon={iconName} height={18} /> {label}
          </OverflowMenuItem>
          {dialog}
        </>
      )}
    </ApiActionButton>
  );
};

export default OverflowMenuApiActionButton;
